import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";

// v1.38.0 Ayarlar → Finans: Banka Kasası vade uyarısı
export default function VaultDueSettings() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/cek-senet/vault-due/settings").then(({ data }) => setS(data)); }, []);
  if (!s) return <div className="h-24 animate-pulse" />;
  const save = async () => { try { setS((await api.put("/cek-senet/vault-due/settings", s)).data); toast.success("Vade uyarısı ayarı kaydedildi"); } catch (e) { toast.error(apiError(e)); } };
  return (
    <div className="panel p-4 space-y-4 max-w-2xl" data-testid="vault-due-settings">
      <div className="text-sm text-slate-600">Portföyde ve <b>Banka Kasası</b>'nda duran çek/senet için vadeden N gün önce, vade günü ve vadesi geçince (her eşikte bir kez) uygulama içi + push bildirimi gönderilir (her gün 09:05). Alıcılar: Süper Yönetici ve çek/senet görüntüleme yetkisi olanlar (satış personeli yalnız kendi evrakı).</div>
      <label className="flex items-center gap-2 text-sm"><Switch checked={s.enabled} onCheckedChange={(v) => setS({ ...s, enabled: v })} data-testid="vault-due-enabled" />Uyarı açık</label>
      <label className="flex items-center gap-2 text-sm">Vadeden kaç gün önce
        <input type="number" min={1} max={90} value={s.days} onChange={(e) => setS({ ...s, days: Number(e.target.value) || 1 })} className="h-8 w-20 rounded border px-2" data-testid="vault-due-days" />
      </label>
      <Button onClick={save} data-testid="vault-due-settings-save">Kaydet</Button>
    </div>
  );
}
